import { render } from "./titleItem.vue?vue&type=template&id=fbe2b3dc&scoped=true"
import script from "./titleItem.vue?vue&type=script&lang=js"
export * from "./titleItem.vue?vue&type=script&lang=js"

import "./titleItem.vue?vue&type=style&index=0&id=fbe2b3dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe2b3dc"]])

export default __exports__